import Search from './Search';
import Menu from './Menu.js';
import Gallery from './Gallery.js';
import Unfold from './Unfold.js';
import LoadMore from './LoadMore.js';
import Scroll from './Scroll.js';
import Carousel from './Carousel.js';
import Share from './Share.js';
import Banner from './Banner.js';
import PopupOpener from './PopupOpener.js';
import Scrollbar from './Scrollbar.js';
import Range from './Range.js';
import Nav from './Nav.js';

const Components = {
    Search: Search,
    Menu: Menu,
    Gallery: Gallery,
    Unfold: Unfold,
    LoadMore: LoadMore,
    Scroll: Scroll,
    Carousel: Carousel,
    Share: Share,
    Banner: Banner,
    PopupOpener: PopupOpener,
    Scrollbar: Scrollbar,
    Range: Range,
    Nav: Nav,
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js